import { render, staticRenderFns } from "./AddExceptionRange.vue?vue&type=template&id=6067a6c0&scoped=true&"
import script from "./AddExceptionRange.vue?vue&type=script&lang=js&"
export * from "./AddExceptionRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6067a6c0",
  null
  
)

export default component.exports